export type ActiveFolder =
  | {
      id: string;
      contextId: string;
    }
  | undefined;
